import {
  CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
  FACILITY_FUNCTION_CATEGORY_CODE,
  HEALTHCARE_FUNCTION_CATEGORY_CODE,
  HOLIDAY_WORKER_APPLICATION_CODE,
  INTERN_APPLICATION_CODE,
  STAFF_AND_ADMINISTRATION_FUNCTION_CATEGORY_CODE,
  STUDENT_APPLICATION_CODE,
  TREATMENT_FUNCTION_CATEGORY_CODE,
  VOLUNTEER_APPLICATION_CODE,
  WELL_BEING_FUNCTION_CATEGORY_CODE,
  ZZP_APPLICATION_CODE,
} from '@constants';

const functionCategoryFilters = [
  {
    applicationForm: VOLUNTEER_APPLICATION_CODE,
    categories: [
      WELL_BEING_FUNCTION_CATEGORY_CODE,
      HEALTHCARE_FUNCTION_CATEGORY_CODE,
      CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
      FACILITY_FUNCTION_CATEGORY_CODE,
    ],
  },
  {
    applicationForm: STUDENT_APPLICATION_CODE,
    categories: [
      WELL_BEING_FUNCTION_CATEGORY_CODE,
      HEALTHCARE_FUNCTION_CATEGORY_CODE,
    ],
  },
  {
    applicationForm: INTERN_APPLICATION_CODE,
    categories: [
      WELL_BEING_FUNCTION_CATEGORY_CODE,
      HEALTHCARE_FUNCTION_CATEGORY_CODE,
      TREATMENT_FUNCTION_CATEGORY_CODE,
      FACILITY_FUNCTION_CATEGORY_CODE,
      CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
      STAFF_AND_ADMINISTRATION_FUNCTION_CATEGORY_CODE,
    ],
  },
  {
    applicationForm: HOLIDAY_WORKER_APPLICATION_CODE,
    categories: [
      WELL_BEING_FUNCTION_CATEGORY_CODE,
      HEALTHCARE_FUNCTION_CATEGORY_CODE,
      CATERING_INDUSTRY_FUNCTION_CATEGORY_CODE,
      FACILITY_FUNCTION_CATEGORY_CODE,
    ],
  },
  {
    applicationForm: ZZP_APPLICATION_CODE,
    categories: [
      HEALTHCARE_FUNCTION_CATEGORY_CODE,
      TREATMENT_FUNCTION_CATEGORY_CODE,
    ],
  },
];

export default functionCategoryFilters;
